export default {"src":"/_next/static/media/ar.aae649f4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};